export default
{
  UnitFinancialPositionStatus: [],
  UnitFinancialPositionStatu: {},
}
